import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { SAN_PARTNERS } from '../../consts';
import LDS from './LDS';
import { partnerShape } from '../types';
import ParametersFactory from './partnerParameters/ParametersFactory';
import css from './PartnerConfigurationShelf.css';

export const AnonymizedPostbacksOptionsForSANs = {
    NONE: 'NONE',
    ANONYMIZED_POSTBACKS_FALSE: 'ANONYMIZED_POSTBACKS_FALSE',
};

export const AnonymizedPostbacksOptions = {
    ...AnonymizedPostbacksOptionsForSANs,
    ANONYMIZED_POSTBACKS_TRUE: 'ANONYMIZED_POSTBACKS_TRUE',
};

export default function UserDataSharingRestrictions({ partner, partnerPrivacyParameters, ldsSupported, isReadonly }) {
    const anonymizedPostbacksOptions = SAN_PARTNERS.includes(partner.name)
        ? AnonymizedPostbacksOptionsForSANs
        : AnonymizedPostbacksOptions;

    return (
        <>
            <div className={css.section}>
                <div className={css.title}>
                    <Translate id="STATIC.PAGES.PARTNER_CONFIGURATION.SHELF.ADVANCED_SETTINGS.PRIVACY_TITLE" />
                </div>
                {ldsSupported && (
                    <LDS
                        partner={partner}
                        isReadonly={isReadonly}
                        anonymizedPostbacksOptions={anonymizedPostbacksOptions}
                    />
                )}
                {partnerPrivacyParameters.length > 0 && (
                    <>
                        <div
                            className={`${
                                !ldsSupported
                                    ? css.privacyParametersSectionWithoutLdsSection
                                    : css.privacyParametersSection
                            }`}
                        >
                            <div className={css.subtitle}>
                                <Translate
                                    id="STATIC.PAGES.PARTNER_CONFIGURATION.SHELF.ADVANCED_SETTINGS.PRIVACY_PARAM_SUBTITLE"
                                    data={{ partnerName: partner.displayName }}
                                />
                            </div>
                            <ParametersFactory parameters={partnerPrivacyParameters} isReadonly={isReadonly} />
                        </div>
                    </>
                )}
            </div>
        </>
    );
}

UserDataSharingRestrictions.propTypes = {
    partner: partnerShape.isRequired,
    ldsSupported: PropTypes.bool,
    partnerPrivacyParameters: PropTypes.array.isRequired,
    isReadonly: PropTypes.bool,
};
